// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3107":"6fdf0c204fd42e3e","5152":"10ff0686291ca0ce"}[chunkId] + ".js";
};